const Warning = ({
  viewBox = "0 0 24 24",
  size = 24,
  color = "#333",
  ...props
}) => (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    p-id="34695"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M945.07 723.29L601.58 186.14c-41.82-65.4-137.35-65.4-179.17 0L78.92 723.29c-45.26 70.78 5.57 163.62 89.59 163.62h686.98c84.01 0 134.85-92.84 89.58-163.62z m-404.91 24.33h-56.91V690.7h56.91v56.92z m0.59-86.82h-57.5l-17.79-276.7h93.08l-17.79 276.7z"
      fill={color}
      p-id="34696"
    ></path>
  </svg>
);

export default Warning;
